/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=new Set(["baseFrequency","diffuseConstant","kernelMatrix","kernelUnitLength","keySplines","keyTimes","limitingConeAngle","markerHeight","markerWidth","numOctaves","targetX","targetY","surfaceScale","specularConstant","specularExponent","stdDeviation","tableValues","viewBox","gradientTransform","pathLength","startOffset","textLength","lengthAdjust"]);export{e as camelCaseAttributes};
//# sourceMappingURL=camel-case-attrs.js.map
